import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  clinicalTriages: [],
  allClinicalTriages: [],
  totalPages: 0,
  totalRecords: 0,
  clinicalTriage: null,
  errorStatus: null,
};
const getters = {
  getApiLoad_15: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_ClinicalTriages(state, clinicalTriages) {
    state.clinicalTriages = clinicalTriages.items;
    state.totalPages = clinicalTriages.totalPages;
    state.totalRecords = clinicalTriages?.totalRecords ?? 0;
  },
  SET_AllClinicalTriages(state, clinicalTriages) {
    state.allClinicalTriages = clinicalTriages;
  },
  SET_ClinicalTriage(state, clinicalTriage) {
    state.clinicalTriage = clinicalTriage;
  },
};
const actions = {
  errorClinicalTriage({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllClinicalTriages({ commit, dispatch, rootState }, chiefComplaintId) {
    let url = '/ClinicalTriages/All?ChiefComplaintId=' + chiefComplaintId;
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_AllClinicalTriages', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorClinicalTriage', error);
      });
  },
  addClinicalTriage({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/ClinicalTriages', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorClinicalTriage', error);
      });
  },
  getClinicalTriage({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/ClinicalTriages/ById?clinicalTriageId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_ClinicalTriage', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorClinicalTriage', error);
      });
  },
  editClinicalTriage({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/ClinicalTriages/Edit', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorClinicalTriage', error);
      });
  },
  deleteClinicalTriage({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/ClinicalTriages/Remove?clinicalTriageId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorClinicalTriage', error);
      });
  },
  activateClinicalTriage({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/ClinicalTriages/Activate?clinicalTriageId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorClinicalTriage', error);
      });
  },
  deactivateClinicalTriage({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/ClinicalTriages/Deactivate?clinicalTriageId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorClinicalTriage', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
